import React, { useState, useEffect, useCallback } from 'react';
import { subscriptionsAPI } from '../../services/api';
import { Activity, Filter } from 'lucide-react';

const fmtDate = (d) => d ? new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—';

export default function SuperAdminActivity() {
  const [activity, setActivity] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const a = await subscriptionsAPI.activity();
      setActivity(a);
    } catch { /* */ }
  }, []);

  useEffect(() => {
    setLoading(true);
    load().finally(() => setLoading(false));
  }, [load]);

  if (loading) return <div className="spinner" style={{ margin: '80px auto' }} />;

  return (
    <div>
      <div className="sa-toolbar">
        <span className="sa-toolbar-title">{activity.length} activity entries</span>
      </div>

      <div className="sa-card">
        <div className="sa-card-body" style={{ padding: '12px 20px' }}>
          {activity.length === 0 ? (
            <div style={{ textAlign: 'center', padding: 60, color: '#94a3b8' }}>
              <Activity size={36} style={{ margin: '0 auto 12px', display: 'block' }} />
              <p style={{ margin: 0 }}>No activity logged yet</p>
            </div>
          ) : (
            <div className="sa-timeline">
              {activity.map((a, i) => {
                const details = (() => { try { return JSON.parse(a.details || '{}'); } catch { return {}; } })();
                const dotColor = a.action === 'activated' || a.action === 'confirmed' ? '#16a34a' :
                                 a.action === 'cancelled' || a.action === 'rejected' ? '#ef4444' :
                                 a.action === 'created' ? '#3b82f6' : '#f59e0b';
                return (
                  <div key={i} className="sa-timeline-item">
                    <div className="sa-timeline-dot" style={{ background: dotColor }} />
                    <div className="sa-timeline-content" style={{ flex: 1 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div className="sa-timeline-text">
                          <strong>{a.company_name}</strong>
                          <span className={`sa-badge-status ${a.action === 'cancelled' ? 'sa-badge-cancelled' : 'sa-badge-active'}`} style={{ marginLeft: 8, fontSize: 10 }}>
                            {a.action}
                          </span>
                        </div>
                        <span className="sa-timeline-time">{fmtDate(a.created_at)}</span>
                      </div>
                      {details.plan_name && <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>Plan: {details.plan_name}</div>}
                      {details.reason && <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>Reason: {details.reason}</div>}
                      {a.performed_by_name && <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>by {a.performed_by_name}</div>}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
